import { Flex, Box, Heading } from "@chakra-ui/react";

export default function AppShell(props) {
  return (
    <Flex direction="column" align="center" m="0 auto" {...props}>
      <Box w="full" mb="2" bg="#f794b9" textAlign="center">
        <Heading color="white" size="lg" my="0.5em">
          Mock Shop by Pride, Not Prejudice
        </Heading>
      </Box>
      {props.children}
    </Flex>
  );
}
